// extracted by mini-css-extract-plugin
export var active = "_ik-2";
export var recordingDot = "_ik-1";
export var recordingIndicator = "_ik-0";